import React, { ReactElement } from 'react'
import { Button, Svg } from 'ui'
import useQueryString from 'utils/useQueryString'
import PrevIcon from 'images/helpPaneSteps/prevstepicon.svg'

export const arrowIconButtonStyle = {
  p: 0,
  width: '3.2rem',
  height: '3.2rem',
  backgroundColor: 'white10',
  borderRadius: '50%',
  flexShrink: 0,
  ':hover': {
    backgroundColor: 'white15',
  },
  '&:hover > svg path': {
    fill: 'aliceBlue60',
  },
  ':disabled': { backgroundColor: 'transparent' },
}

export default function PreviousStepButton({ onClick }: { onClick: () => void }): ReactElement {
  const { qs } = useQueryString()

  const currentStep = +(qs.step ?? 0)
  return (
    <Button
      data-testid="setup-guide-prev-step-arrow"
      ariaLabel="Previous step"
      sx={arrowIconButtonStyle}
      variant="simple"
      disabled={!currentStep}
      onClick={onClick}
    >
      {!!currentStep && (
        <Svg
          svg={PrevIcon}
          fill="aliceBlue60"
          sx={{ width: '2rem', height: '2rem' }}
          descriptiveText="Previous step arrow"
        />
      )}
    </Button>
  )
}
